<template>
  <SkeletonLoader>
    <div class="ps-skeleton">
      <!-- Alert/info banner -->
      <div class="ps-skeleton__banner">
        <div class="sk-line sk-line--lg" style="width: 55%;"></div>
        <div class="sk-line" style="width: 85%;"></div>
        <div class="sk-line" style="width: 60%;"></div>
      </div>

      <!-- Forms/Templates table -->
      <div class="ps-skeleton__card">
        <div class="sk-line sk-line--title" style="width: 45%; margin-bottom: 14px;"></div>
        <div class="ps-skeleton__table">
          <div class="ps-skeleton__header">
            <div class="sk-rect" style="height: 14px; width: 30px;"></div>
            <div class="sk-rect" style="height: 14px; width: 40%;"></div>
            <div class="sk-rect" style="height: 14px; width: 20%;"></div>
          </div>
          <div v-for="i in 5" :key="'row-'+i" class="ps-skeleton__row">
            <div class="sk-rect" style="height: 16px; width: 16px; border-radius: 3px;"></div>
            <div class="sk-line" :style="{ width: nameWidths[i] }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: typeWidths[i] }"></div>
          </div>
        </div>
        <div style="margin-top: 12px; display: flex; gap: 8px;">
          <div class="sk-rect" style="height: 32px; width: 70px; border-radius: 6px;"></div>
          <div class="sk-rect" style="height: 32px; width: 70px; border-radius: 6px;"></div>
        </div>
      </div>

      <!-- Second table (wiki templates) -->
      <div class="ps-skeleton__card">
        <div class="sk-line sk-line--title" style="width: 55%; margin-bottom: 14px;"></div>
        <div class="ps-skeleton__table">
          <div class="ps-skeleton__header">
            <div class="sk-rect" style="height: 14px; width: 30px;"></div>
            <div class="sk-rect" style="height: 14px; width: 50%;"></div>
          </div>
          <div v-for="i in 3" :key="'wiki-'+i" class="ps-skeleton__row">
            <div class="sk-rect" style="height: 16px; width: 16px; border-radius: 3px;"></div>
            <div class="sk-line" :style="{ width: wikiWidths[i] }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'PatientSidebarSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      nameWidths: { 1: '60%', 2: '45%', 3: '70%', 4: '55%', 5: '50%' },
      typeWidths: { 1: '40%', 2: '55%', 3: '35%', 4: '50%', 5: '45%' },
      wikiWidths: { 1: '65%', 2: '50%', 3: '55%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.ps-skeleton {
  padding: 16px;
}

.ps-skeleton__banner {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
  padding: 14px 16px;
  margin-bottom: 16px;

  .sk-line { background-image: linear-gradient(90deg, #c3e6cb 0px, #d8f0de 40px, #c3e6cb 80px) !important; background-color: #c3e6cb !important; }
}

.ps-skeleton__card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 14px;
}

.ps-skeleton__table {
  margin-top: 8px;
}

.ps-skeleton__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 0;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 4px;
}

.ps-skeleton__row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}
</style>
